import './bootstrap';
import './particles.min';
import '../css/extra.css';
import 'leaflet/dist/leaflet.css';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import './echo';
import axios from 'axios';
import { showModal, closeModal, closeModalSubDetails, closeModalCheckOut } from './helper/showModal.js';
import { showModalPenjadwalan, closeModalPenjadwalan } from './tabForm/penjadwalan/index.js';
import { showModalDriver, closeModalDriver, showModalImageDriver, closeModalImageDriver } from './tabForm/driver/index.js';
import { batalOrder } from './tabForm/report/index.js';
import { openModalDriver } from './dashAdmin/driver/index.js';
import { openModalBBM, closeModalBBM } from './dashAdmin/bbm/index.js';
import { showModalPromo, hideModalPromo } from './dashAdmin/promo/index.js';
import { showModalTarifTuslah, hideModalTarifTuslah } from './dashAdmin/tarifTuslah/index.js';
import { openModalKategoriUnit, closeModalKategoriUnit } from './dashAdmin/kategoriUnit/index.js'
import { openModalTypeUnit, closeModalTypeUnit } from './dashAdmin/typeUnit/index.js'
// import { openModalUnit, closeModalUnit } from './dashAdmin/unit/index.js'
import { openModalDriverKategori, closeModalDriverKategori } from './dashAdmin/driverKategori/index.js'
import { openModalDriverDetails, closeModalDriverDetails } from './dashAdmin/orderDriver/index.js';
import './tabForm/pelaporan/summary.js'

// Global Alpine Setup
Alpine.plugin(collapse);
window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
    Alpine.store('tripTabsPelayanan', {
        activeTab: 'tab1',

        setTab(tabValue) {
            this.activeTab = tabValue;
        }
    });
});

Alpine.start();

// Ekspor semua modal function ke global
window.batalOrder = batalOrder;
window.showModal = showModal;
window.closeModal = closeModal;
window.showModalPenjadwalan = showModalPenjadwalan;
window.closeModalPenjadwalan = closeModalPenjadwalan;
window.showModalDriver = showModalDriver;
window.closeModalDriver = closeModalDriver;
window.showModalImageDriver = showModalImageDriver;
window.closeModalImageDriver = closeModalImageDriver;
window.closeModalSubDetails = closeModalSubDetails;
window.closeModalCheckOut = closeModalCheckOut;
window.openModalDriver = openModalDriver;
window.openModalBBM = openModalBBM;
window.closeModalBBM = closeModalBBM;
window.showModalPromo = showModalPromo;
window.hideModalPromo = hideModalPromo;
window.showModalTarifTuslah = showModalTarifTuslah;
window.hideModalTarifTuslah = hideModalTarifTuslah;
window.openModalKategoriUnit = openModalKategoriUnit;
window.closeModalKategoriUnit = closeModalKategoriUnit;
window.openModalTypeUnit = openModalTypeUnit;
window.closeModalTypeUnit = closeModalTypeUnit;
// window.openModalUnit = openModalUnit;
// window.closeModalUnit = closeModalUnit;
window.openModalDriverKategori = openModalDriverKategori;
window.closeModalDriverKategori = closeModalDriverKategori;
window.openModalDriverDetails = openModalDriverDetails;
window.closeModalDriverDetails = closeModalDriverDetails;

document.addEventListener("DOMContentLoaded", () => {
    // Init flatpickr
    flatpickr(".datetimepicker", {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
    });

    // --- Chat Widget ---
    const chatToggle = document.getElementById("chat-toggle");
    const chatBox = document.getElementById("chat-box");
    const chatClose = document.getElementById("chat-close");
    const chatForm = document.getElementById("chat-form");
    const chatInput = document.getElementById("chat-input");
    const chatMessages = document.getElementById("chat-messages");

    if (chatToggle && chatBox && chatClose && chatForm && chatInput && chatMessages) {

        // Toggle chat box
        chatToggle.addEventListener("click", () => chatBox.classList.toggle("hidden"));
        chatClose.addEventListener("click", () => chatBox.classList.add("hidden"));

        // Send message
        chatForm.addEventListener("submit", async (e) => {
            e.preventDefault();
            const message = chatInput.value.trim();
            if (!message) return;

            appendMsg(message, 'me');
            chatInput.value = '';

            // Kirim ke server
            await fetch('/chat/send', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]').getAttribute('content')
                },
                body: JSON.stringify({ message })
            });
        });

        // Append message function
        function appendMsg(text, who='me', meta=null) {
            const wrap = document.createElement('div');
            wrap.className = `mb-2 flex ${who === 'me' ? 'justify-end' : 'justify-start'}`;

            const bubble = document.createElement('div');
            bubble.className = `max-w-[75%] text-sm px-3 py-2 rounded-lg ${
              who === 'me' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-800'
            }`;

            bubble.innerHTML = meta?.name ? `<div class="font-medium mb-1">${meta.name}</div>${text}` : text;
            wrap.appendChild(bubble);
            chatMessages.appendChild(wrap);
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }

        // Listen pesan dari user lain via Echo
        if (window.Echo) {
            window.Echo.private('chat.global')
                .listen('.message.sent', (e) => {
                    appendMsg(e.message, 'other', { name: e.user?.name || 'User' });
                });
        }
    }

    axios.interceptors.response.use(
    res => res,
    async error => {
        // Jika token expired
        if (error.response?.status === 419) {

            // Jangan refresh token kalau user belum login!
            if (!document.body.dataset.auth || document.body.dataset.auth === "0") {
                return Promise.reject(error);
            }

            await axios.get('/sanctum/csrf-cookie');

            error.config.headers['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]')?.content;

            return axios(error.config);
        }

        return Promise.reject(error);
    }
    );

    // refresh token tiap 5 menit untuk prevent 419
    if (document.body.dataset.auth === "1") {
        setInterval(refreshCsrf, 300000);
    }
    async function refreshCsrf() {
        try {
            const response = await axios.get('/refresh-csrf');
            const newCsrf = response.data.csrf;
            document.querySelector('meta[name="csrf-token"]').setAttribute('content', newCsrf);
        } catch (error) {
            console.error('Gagal refresh CSRF token:', error);
        }
    }
});
